import NumToWord from 'number-to-words';
import { currencyFormat, dateFormatThree } from '../../../Functions';

export function CANHeadCompose(page, rowL, ll, dataUrl) {
    var doc = ll;
    var _y = rowL;
    var _space = page.spacingunit;

    var imageX = 140;

    doc.addImage(dataUrl, 'JPEG', imageX, page.headerFromTop, 55, 25);
    _y += _space * 2;

    return _y;
}

export function CANBodyContentCompose(page, rowL, ll, data) {
    // console.log('pdf data', data)
    var doc = ll;
    var _y = rowL;
    var _space = page.spacingunit;
    const margin = 10;

    doc.setFont("times", "bold");
    doc.text('CARGO ARRIVAL NOTICE', 110, _y, null, null, 'center');
    doc.setFont("times", "normal");
    _y += _space * 2;

    //headers
    doc.text(margin, _y, `Vessel: ${data[0].vessel}`);
    let current_datetime = new Date()
    let formatted_date = (current_datetime.getMonth() + 1) + "/" + current_datetime.getDate() + "/" + current_datetime.getFullYear();
    doc.text(130, _y, 'Date: ' + formatted_date);
    _y += _space;
    doc.text(margin, _y, 'Voyage Sequence: ' + data[0].voyage);
    doc.text(130, _y, 'Voyage Reference: ' + data[0].voyageRef);
    _y += _space * 1.5;

    doc.text(margin, _y, 'Port of Origin:');
    doc.text(60, _y, data[0].origin ? data[0].origin : '');
    doc.line(60, _y + 1, 120, _y + 1);

    let Arrival_datetime = new Date(data[0].etd)
    let Arrivalformatted_date = (Arrival_datetime.getMonth() + 1) + "/" + Arrival_datetime.getDate() + "/" + Arrival_datetime.getFullYear();
    doc.text(130, _y, 'ATD:');
    doc.text(140, _y, Arrivalformatted_date);
    doc.line(140, _y + 1, 200, _y + 1);

    _y += _space;
    doc.text(margin, _y, 'Port of Destination:');
    doc.text(60, _y, data[0].destination ? data[0].destination : '');
    doc.line(60, _y + 1, 120, _y + 1);

    let Esti_datetime = new Date(data[0].arrivalDate)
    let Estiformatted_date = (Esti_datetime.getMonth() + 1) + "/" + Esti_datetime.getDate() + "/" + Esti_datetime.getFullYear();
    doc.text(130, _y, `ATA:`);
    doc.text(140, _y, Estiformatted_date);
    doc.line(140, _y + 1, 200, _y + 1);
    _y += _space;

    doc.text(margin, _y, `Pull Out CY:`);
    doc.text(60, _y, data[0].cyPullOutName ? data[0].cyPullOutName : '');
    doc.line(60, _y + 1, 120, _y + 1);

    doc.text(130, _y, `Finished Unloading:`);
    if(data[0].finalcy && data[0].finalcy.finalizeDate){
        let finalizeDate = new Date(data[0].finalcy.finalizeDate)
        let finalizeDate_date = (finalizeDate.getMonth() + 1) + "/" + finalizeDate.getDate() + "/" + finalizeDate.getFullYear();
        doc.text(160, _y, finalizeDate_date);
    }
    doc.line(160, _y + 1, 200, _y + 1);

    _y += _space * 1.5;

    doc.text(margin, _y, 'Shipper:');
    doc.text(60, _y, data[0].shipper ? data[0].shipper : '');
    doc.line(60, _y + 1, 200, _y + 1);
   
    if(data[0].shipperPreferedName){
        _y += _space;
        doc.text(margin, _y, 'Shipper Preferred Name:');
        doc.text(60, _y, data[0].shipperPreferedName ? data[0].shipperPreferedName : '');
        doc.line(60, _y + 1, 200, _y + 1);
    }

    _y += _space;
    doc.text(margin, _y, 'Consignee:');
    doc.text(60, _y, data[0].consigneeName ? data[0].consigneeName : '');
    doc.line(60, _y + 1, 200, _y + 1);

    if(data[0].consigneePreferedName){
        _y += _space;
        doc.text(margin, _y, 'Consignee Preferred Name:');
        doc.text(65, _y, data[0].consigneePreferedName ? data[0].consigneePreferedName : '');
        doc.line(65, _y + 1, 200, _y + 1);
    }
    
    _y += _space * 1.5;

    doc.text(margin, _y, 'BOOKING');
    doc.text(margin * 2.7, _y, 'WAYBILL');
    doc.text(margin * 5.2, _y, 'VAN #');
    doc.text(margin * 7.8, _y, 'SEAL #');
    doc.text(margin * 10, _y, 'CARGO');
    doc.text(margin * 12.2, _y, 'MOD');
    doc.text(margin * 13.1, _y, 'MOP');
    doc.text(margin * 14, _y, 'STORAGE DUE DATE');
    doc.text(margin * 17.6, _y, 'RELEASE TYPE');
    doc.line(margin, _y + 1, 201, _y + 1);
    _y += _space;

    data.forEach(element => {
        var freeStorage = element.terms.find(term => term.code === 'C0001');
        var storageVal = freeStorage ? freeStorage.amount : 0;
        let tallyDate = element.finalcy ? element.finalcy.finalizeDate ? element.finalcy.finalizeDate : null : null;
        let dueDate = "";
        if(tallyDate){
            if(element.destination === "MNL"){
                let NewTD = new Date(tallyDate);
                NewTD.setDate(NewTD.getDate() + storageVal);
                dueDate = dateFormatThree(NewTD);
            }
            else {
                let FinalDay;
                let dayCount = 0;
                for (let x = 0; x < 999; x++) {
                    let NewTD = new Date(tallyDate);
                    NewTD.setDate(NewTD.getDate() + x);
                    let day = NewTD.getDay();
                    if(day !== 0){                   
                        if(dayCount === storageVal){
                            FinalDay = NewTD;
                            break;
                        }
                        dayCount++;
                    }
                    else if(day === 0 && x === 0){
                        dayCount++;
                    }
                }
                if(FinalDay){
                    dueDate = dateFormatThree(FinalDay);
                }
            }
        }
    
        doc.text(margin, _y, element.bookingRef ? element.bookingRef : '');
    
        doc.text(margin * 2.7, _y, element.wayBillRef ? element.wayBillRef : '');
    
        doc.text(margin * 5.2, _y, element.cargo ? element.cargo : '');
    
        doc.text(margin * 7.8, _y, element.sealNum ? element.sealNum : '');
    
        var splitMargin = (margin * 12.2) - (margin * 10);
        var splitGoods = doc.splitTextToSize(element.goods ? element.goods : '', splitMargin);
        doc.text(margin * 10, _y, splitGoods);
    
        doc.text(margin * 12.2, _y, element.modeOfDelivery ? element.modeOfDelivery : '');
        var mop = "";
        if(element.modeOfPayment === "Prepaid"){mop = "P";}
        else if(element.modeOfPayment === "Collect"){mop = "C";}
        else if(element.modeOfPayment === "Account Origin"){mop = "AO";}
        else if(element.modeOfPayment === "Account Destination"){mop = "AD";}
        doc.text(margin * 13.1, _y, mop);

        // doc.text(margin * 15.5, _y, storageVal + ' days');
        // doc.text(margin * 14, _y, storageVal + ' days');
        doc.text(margin * 14, _y, dueDate);
        
        let releasetype = "";
        if(element.modeOfDelivery === "PTP" || element.modeOfDelivery === "DTP"){
            if(element.isStripping){
                if(element.strippingType === "011") {
                    releasetype = "CY Stripping Mano";
                }
                else if(element.strippingType === "010") {
                    releasetype = "CY Stripping Area";
                }
                else if(element.strippingType === "ALL") {
                    // releasetype = "CY Stripping Area and CY Stripping Mano";
                    releasetype = "All";
                }
            }
            else {
                releasetype = "Van Out";
            }
        }
        else {
            if(element.isStripping){
                if(element.strippingType === "012") {
                    releasetype = "Door Delivery with Stripping Mano";
                }
            }
            else {
                releasetype = "Door Delivery";
            }
        }

        var releaseSplitMargin = (201) - (margin * 17.6);
        var splitRelease = doc.splitTextToSize(releasetype, releaseSplitMargin);
        doc.text(margin * 17.6, _y, splitRelease);

        if (splitGoods.length > 1) {
            if (splitRelease.length > 1 && splitRelease.length > splitGoods.length) {
                _y += (_space * splitRelease.length);
            }
            else {
                _y += (_space * splitGoods.length);
            }
        }
        else {
            if (splitRelease.length > 1) {
                _y += (_space * splitRelease.length);
            }
            else {
                _y += _space;
            }
        }

        _y -= _space;
        doc.line(margin, _y + 1, 201, _y + 1);

        _y += _space;
    
    });

    _y += _space;
    
    // let due_datetime = new Date()
    // let DueFormatted_date = (due_datetime.getMonth() + 1) + "/" + due_datetime.getDate() + "/" + due_datetime.getFullYear();
    // doc.text(margin * 18, _y, DueFormatted_date);

    // _y += _space * 1.5;

    doc.text(margin, _y, 'Remarks:');
    _y += _space;
    // let remarkList = [];
    // data.forEach(element => {
    //     if(element.remarks && element.remarks !== ""){
    //         remarkList.push("BookRef: " + element.bookingRef + " - " + element.remarks); 
    //     }
    // })
    // let reMark = remarkList.join(', ');
    // let remark = doc.splitTextToSize(reMark ? reMark : '', 190);

    // doc.text(margin, _y, remark ? remark : '');
    // if(remark.length > 1){
    //     for (let x = 0; x < remark.length; x++) {
    //         doc.line(margin, _y + 1, 200, _y + 1);
    //         _y += (_space * 0.8);
    //     }
    //     _y -= _space;
    // }
    // else {
        doc.line(margin, _y + 1, 200, _y + 1);
    // }

    // _y += _space;
    // doc.line(margin, _y + 1, 200, _y + 1);

    _y += _space * 3;

    return _y
}

export function CANGuidelineCondition(page, rowL, ll, data) {
    var doc = ll;
    var _y = rowL;
    var _space = page.spacingunit;
    const margin = 10;
    // console.log('data[0]', data[0])
    if(data[0].terms && data[0].terms.length > 0){
        var ct1 = data[0].terms.find(TC => TC.code === "C0001");
        var ctn1 = ct1 && ct1.amount > 0 ? ct1.amount.toString() : 0;

        var ct2 = data[0].terms.find(TC => TC.code === "C0002");
        var ctn2 = ct2 && ct2.amount > 0 ? ct2.amount.toString() : 0;

        var ct3 = data[0].terms.find(TC => TC.code === "C0003");
        var ctn3 = ct3 && ct3.amount > 0 ? currencyFormat(ct3.amount).toString() : 0;

        var ct4 = data[0].terms.find(TC => TC.code === "C0004");
        var ctn4 = ct4 && ct4.amount > 0 ? currencyFormat(ct4.amount).toString() : 0;

        var ct5 = data[0].terms.find(TC => TC.code === "C0005");
        var ctn5 = ct5 && ct5.amount > 0 ? ct5.amount.toString() * 100 : 0;

        var ct7 = data[0].terms.find(TC => TC.code === "C0007");
        var ctn7 = ct7 && ct7.amount > 0 ? ct7.amount.toString() : 0;

        var ct13 = data[0].terms.find(TC => TC.code === "C0013");
        var ctn13 = ct13 && ct13.amount > 0 ? currencyFormat(ct13.amount).toString() : 0;

        var GC1, GC2, GC2P1, GC2P2, GC3, GC4, GC5, GC6, GC7;

        GC1 = doc.splitTextToSize('1. Free storage is strictly ' + NumToWord.toWords(ctn1) + ' ('+ ctn1 +') days upon vessel arrival.'
        + ' Any unwithdrawn cargoes beyond the free storage shall be subject to a storage fee of P' + ctn3 + ''
        + ' per teu per day.', page.maxWidthInPoint + 10);

        GC2 = doc.splitTextToSize('2. In the event of actual withdrawal of cargoes, the consignee/representative'
        + ' shall present the following documents to our releasing in-charge:', page.maxWidthInPoint + 10);

        GC2P1 = doc.splitTextToSize('- Cargo Arrival Notice', page.maxWidthInPoint + 10);

        GC2P2 = doc.splitTextToSize('- Letter of authorization, signed by the consignee/authorized representative'
        + ' of the consignee (for haulers/truckers and person other than the consignee).', page.maxWidthInPoint + 10);

        GC3 = doc.splitTextToSize('3. Any unreturned container, beyond the ' + NumToWord.toWords(ctn2) + ' ('+ ctn2 +') days free detention from date'
        + ' of container pull-out or delivery, shall be subject to detention/demurrage fee of P'+ ctn13 +' per day'
        + ' per teu. This shall be chargeable to the account of the shipper/consignee.', page.maxWidthInPoint + 10);

        GC4 = doc.splitTextToSize('4. For any damaged cargo, consignee shall submit an incident report to our CSR'
        + ' within twenty-four (24) hours after the cargo has been release, delivered, or discovered. Our CSR shall'
        + ' then assign a claims surveyor to assess the damage as reported. After which, consignee shall evaluate'
        + ' the damage and send a CLAIMS LETTER to our CSR within ' + NumToWord.toWords(ctn7) + ' ('+ ctn7 +') days. Note: No claims shall be'
        + ' entertained beyond ' + NumToWord.toWords(ctn1) + ' ('+ ctn1 +') days upon vessel arrival.', page.maxWidthInPoint + 10);

        GC5 = doc.splitTextToSize('5. No cargo shall be released without complete fulfilment of payment/s.', page.maxWidthInPoint + 10);

        GC6 = doc.splitTextToSize('6. Please make check payable to OCEAN TRANSPORT GROUP OF COMPANIES, INC.', page.maxWidthInPoint + 10);

        GC7 = doc.splitTextToSize('7. Insurance coverage of up to P' + ctn4 + ' declared value per 20 footer van'
        + ' is included. Otherwise, an insurance premium will be charged at '+ ctn5 +'% per thousand of the excess'
        + ' declared value.', page.maxWidthInPoint + 15);

        if (_y > 170) {
            doc.addPage(page.layout, page.papersize.unit, page.papersize.format);
            _y = page.margin.top;
        }

        doc.text(margin, _y, 'Guidelines & Conditions:');
        _y += _space * 2;
    
        doc.text(margin, _y, GC1);
        _y += ((_space * GC1.length));
    
        doc.text(margin, _y, GC2);
        _y += ((_space * GC2.length));
    
        doc.text(margin, _y, GC2P1);
        _y += ((_space * GC2P1.length));
    
        doc.text(margin, _y, GC2P2);
        _y += ((_space * GC2P2.length));
       
        doc.text(margin, _y, GC3);
        _y += ((_space * GC3.length));
    
        doc.text(margin, _y, GC4);
        _y += ((_space * GC4.length));
    
        doc.text(margin, _y, GC5);
        _y += ((_space * GC5.length));
    
        doc.text(margin, _y, GC6);
        _y += ((_space * GC6.length));
    
        doc.text(margin, _y, GC7);
    }
}